module.exports = __webpack_public_path__ + "img/reset-step-three.3428f2a5.png";